import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Col, Row, Button, Icon, Select, Input, Upload } from 'antd';
import classNames from 'classnames/bind';
import Enum from 'utils/EnumsManager';
import { Panel } from 'components/ui/index';
import ExportTemplateModal from './ExportTemplateModal';
import { importFileWithObject } from '../flow/action';
import styles from '../index.less';

const { Leads } = Enum.ObjectTypes;
const { Option } = Select;
const InputGroup = Input.Group;
const cx = classNames.bind(styles);

class FileImport extends React.Component {
  state ={
    objectType: Leads,
    fileName: '',
    fileData: '',
    uploadBtnDistabled: true,
  }

  beforeUpload = (file, fileList) => {
    if (file) {
      this.setState({
        fileName: file.name,
        fileData: file,
        uploadBtnDistabled: false,
      });
    }
    return false;
  }

  handleImportFinish = () => {
    this.setState({
      fileName: '',
      fileData: '',
      uploadBtnDistabled: true,
    });
  }

  handleImport = () => {
    const { objectType, fileData } = this.state;
    const { importFileWithObject } = this.props;
    const formData = new FormData();
    formData.append('object_type', objectType);
    formData.append('file', fileData);
    importFileWithObject(formData, () => this.handleImportFinish());
  }

  render() {
    const { objectType, fileName, uploadBtnDistabled } = this.state;
    const uploadProps = {
      name: 'document',
      accept: '.csv',
      showUploadList: false,
      beforeUpload: this.beforeUpload,
    };

    return (
      <Panel
        panelTitle={<FormattedMessage id="page.ObjectImport.import" />}
        contentClasses={cx('panel-content-container')}
        actionsRight={
          <ExportTemplateModal />
        }
      >
        <div className={cx('import-select-container', 'custom-container')}>
          <Row gutter={16}>
            <Col span={2} className="text-left ml-lg">
              <FormattedMessage id="page.ObjectImport.selectObject">
                {text => <span className={cx('import-select-label')}>{text}:</span>}
              </FormattedMessage>
            </Col>
            <Col span={8}>
              <Select className="full-width" value={objectType}>
                <Option value={Leads}><FormattedMessage id={`global.sider.${Leads}`} /></Option>
              </Select>
            </Col>
          </Row>
          <Row gutter={16} className="mt-md">
            <Col span={2} className="text-left ml-lg">
              <FormattedMessage id="page.ObjectImport.selectFile">
                {text => <span className={cx('import-select-label')}>{text}:</span>}
              </FormattedMessage>
            </Col>
            <Col span={8}>
              <InputGroup compact>
                <Input style={{ width: '80%' }} value={fileName} />
                <Upload {...uploadProps} className={classNames('setup-file-import', cx('setup-file-import'))}>
                  <Button className="full-width">
                    <Icon type="folder-open" className="mr-sm" />
                    <FormattedMessage id="page.ObjectImport.select" />
                  </Button>
                </Upload>
              </InputGroup>
            </Col>
          </Row>
          <Row gutter={16} className="mt-md">
            <Col span={8} className="ml-lg">
              <Button className={cx('setup-file-importBtn')} disabled={uploadBtnDistabled} onClick={() => this.handleImport()}>
                <FormattedMessage id="page.ObjectImport.import" />
              </Button>
            </Col>
          </Row>
        </div>
      </Panel>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  lang: global.language
});

const mapDispatchToProps = {
  importFileWithObject
};

export default connect(mapStateToProps, mapDispatchToProps)(FileImport);



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/component/FileImport.jsx